import { render } from "./OpportunityMap.vue?vue&type=template&id=20c6b6b6&scoped=true"
import script from "./OpportunityMap.vue?vue&type=script&lang=js"
export * from "./OpportunityMap.vue?vue&type=script&lang=js"

import "./OpportunityMap.vue?vue&type=style&index=0&id=20c6b6b6&scoped=true&lang=css"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c6b6b6"]])

export default __exports__